import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Loader from './nav/Loader';

import { connect } from "react-redux";
import { getMVPResults } from "../actions/action_mvp";

class MVP extends Component {
  constructor(props) {
      let columns = [
        {Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.gid}>{props.value}</a>},
        {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.gid}>{props.value}</a>},
        {Header: 'Floor', accessor: 'fxsum'},
        {Header: 'Phorse', accessor: 'phsum'},
        {Header: 'Rings', accessor: 'srsum'},
        {Header: 'Vault', accessor: 'vtsum'},
        {Header: 'Pbars', accessor: 'pbsum'},
        {Header: 'Highbar', accessor: 'hbsum'},
        {Header: 'Total', accessor: 'total', style: {fontWeight : 'bold'}},
      ];
      super(props);
      this.state = {
        cols: columns
      }
      this.defaultSortMethod = this.defaultSortMethod.bind(this);
      this.getTable = this.getTable.bind(this);
  }
  componentDidMount() {
    this.props.getMVPResults({
      year: this.props.yearFilter,
      team: this.props.teamFilter
    });
  }
  componentDidUpdate(prevProps) {
    if(Number(prevProps.teamFilter) !== Number(this.props.teamFilter)
      || Number(prevProps.yearFilter) !== Number(this.props.yearFilter)){
      this.props.getMVPResults({
        year: this.props.yearFilter,
        team: this.props.teamFilter
      });
    }
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  getTable() {
    if(!this.props.showLoader) {
      if(this.props.numRows > 0){
        return <div className="small-12 columns">
        <ReactTable
          className="-striped -highlight"
          data={this.props.data}
          columns={this.state.cols}
          defaultSortMethod={this.defaultSortMethod}
          showPagination={false}
          defaultPageSize={this.props.numRows}
          pageSize={this.props.numRows}
        /><br />
        <p className="note">*This chart shows total points contributed by all athlets on a team. Sort by clicking on the column headers.</p>
        </div>;
      } else {
        return <div>No records for this season</div>
      }
    } else {
      return <Loader />;
    }
  }
  render() {
    return (
      <div>
          <div className="row">
            {this.getTable()}
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    data: state.mvp.data,
    numRows: state.mvp.numRows,
    showLoader: state.mvp.showLoader
  };
}

export default connect(mapStateToProps, { getMVPResults })(MVP);
